import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";

// A stale deploy: the browser holds the old index, whose lazy chunks (e.g.
// the drawing editor) no longer exist on the server. Reloading fixes it.
const isStaleChunk = (error) =>
  /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(
    String(error?.message || error),
  );

/**
 * The router's error page (App.jsx): what shows if a page crashes while
 * rendering, instead of React Router's default (an unstyled stack trace).
 * It says what happened and offers the fix — a reload — without the
 * internals; the details go to the console.
 */
function AppError() {
  const error = useRouteError();
  const stale = isStaleChunk(error);

  useEffect(() => {
    console.error("mono: a page failed to render", error);
  }, [error]);

  return (
    <div className="page-container py-12 text-center" role="alert">
      <div className="mx-auto max-w-xl">
        <h1 className="mb-4 font-display text-4xl font-semibold tracking-tight">
          {stale ? "mono was updated" : "Something went wrong"}
        </h1>
        <p className="mb-6 text-muted-foreground">
          {stale
            ? "A new version is out and this page needs it. Reload to pick it up — nothing you saved is lost."
            : "This page hit an error. Reloading usually fixes it; anything already saved is safe."}
        </p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </div>
  );
}

export default AppError;
